(function () {
  'use strict';

  if (window.PGProductHomepageLikenessV41) return;
  window.PGProductHomepageLikenessV41 = true;

  var examples = [
    {
      label: 'Pearl Princess portrait example',
      before: 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/pg-likeness-pearl-princess-before.jpg',
      after: 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/pg-likeness-pearl-princess-artwork.jpg',
      beforeAlt: 'Original customer photo of a black dog used for The Pearl Princess custom pet portrait',
      afterAlt: "The Pearl Princess custom pet portrait created from the customer's black dog photo"
    },
    {
      label: 'Ali G portrait example',
      before: 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/pg-likeness-alig-before.jpg',
      after: 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/pg-likeness-alig-artwork.jpg',
      beforeAlt: 'Original customer photo of a small brown dog used for the Ali G style custom pet portrait',
      afterAlt: "Finished Ali G style custom pet portrait created from the customer's small brown dog photo"
    },
    {
      label: 'Cartoon Duo portrait example',
      before: 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/pg-likeness-cartoon-before.jpg',
      after: 'https://cdn.shopify.com/s/files/1/0437/7398/4922/files/pg-likeness-cartoon-artwork.jpg',
      beforeAlt: 'Original customer photo of two dogs used for a custom cartoon pet portrait',
      afterAlt: "Finished custom cartoon portrait of two dogs created from the customer's photo"
    }
  ];

  function createPanel(label, src, alt, artwork) {
    var panel = document.createElement('figure');
    panel.className = 'pg-likeness-compare__panel' + (artwork ? ' pg-likeness-compare__panel--artwork' : '');

    var media = document.createElement('div');
    media.className = 'pg-likeness-compare__media';

    var image = document.createElement('img');
    image.src = src;
    image.width = 900;
    image.height = 1125;
    image.loading = 'lazy';
    image.decoding = 'async';
    image.alt = alt;

    var badge = document.createElement('span');
    badge.className = 'pg-likeness-compare__label';
    badge.textContent = label;

    media.appendChild(image);
    media.appendChild(badge);
    panel.appendChild(media);
    return panel;
  }

  function createCard(example, photoLabel, portraitLabel) {
    var card = document.createElement('div');
    card.className = 'pg-likeness-compare__card';
    card.setAttribute('role', 'group');
    card.setAttribute('aria-label', example.label);

    var arrow = document.createElement('span');
    arrow.className = 'pg-likeness-compare__arrow';
    arrow.setAttribute('aria-hidden', 'true');
    arrow.innerHTML = '&#8594;';

    card.appendChild(createPanel(photoLabel, example.before, example.beforeAlt, false));
    card.appendChild(arrow);
    card.appendChild(createPanel(portraitLabel, example.after, example.afterAlt, true));
    return card;
  }

  function createSlide(card, label, index) {
    var slide = document.createElement('article');
    slide.className = 'pg-likeness-compare__slide';
    slide.setAttribute('aria-label', 'Example ' + index + ' of 4: ' + label);
    slide.appendChild(card);
    return slide;
  }

  function createDots() {
    var dots = document.createElement('div');
    dots.className = 'pg-likeness-compare__dots';
    dots.setAttribute('data-pg-likeness-dots', '');
    dots.setAttribute('aria-label', 'Choose a before and after example');

    for (var index = 0; index < 4; index += 1) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Show example ' + (index + 1));
      if (index === 0) {
        dot.className = 'is-active';
        dot.setAttribute('aria-current', 'true');
      }
      dots.appendChild(dot);
    }

    return dots;
  }

  function build(root) {
    if (!root || root.dataset.pgV41ExactReady === 'true') return;

    var inner = root.querySelector('.pg-likeness-compare__inner');
    var existingCard = inner && inner.querySelector('.pg-likeness-compare__card');
    var footer = inner && inner.querySelector('.pg-likeness-compare__footer');
    if (!inner || !existingCard || !footer) return;

    var labels = existingCard.querySelectorAll('.pg-likeness-compare__label');
    var photoLabel = labels[0] ? labels[0].textContent.trim() : 'Your Photo';
    var portraitLabel = labels[1] ? labels[1].textContent.trim() : 'Your Portrait';

    var viewport = document.createElement('div');
    viewport.className = 'pg-likeness-compare__viewport';

    var rail = document.createElement('div');
    rail.className = 'pg-likeness-compare__rail';
    rail.setAttribute('data-pg-likeness-rail', '');
    rail.setAttribute('tabindex', '0');
    rail.setAttribute('aria-label', 'Before and after customer portrait examples');

    rail.appendChild(createSlide(existingCard, 'Italian Greyhound portrait example', 1));
    examples.forEach(function (example, index) {
      rail.appendChild(createSlide(createCard(example, photoLabel, portraitLabel), example.label, index + 2));
    });

    viewport.appendChild(rail);

    var cue = document.createElement('p');
    cue.className = 'pg-swipe-cue pg-swipe-cue--likeness';
    cue.setAttribute('data-pg-swipe-cue', '');
    cue.innerHTML = '<span aria-hidden="true">&#8592;</span> Go on... have a little swipe <span aria-hidden="true">&#8594;</span>';

    root.setAttribute('data-pg-likeness-slider', '');
    root.dataset.pgV41ExactReady = 'true';
    inner.insertBefore(viewport, footer);
    inner.insertBefore(createDots(), footer);
    inner.insertBefore(cue, footer);
  }

  function apply() {
    document.querySelectorAll('body.product .pg-likeness-compare').forEach(build);
  }

  function boot() {
    apply();
    [120, 400, 900, 1800].forEach(function (delay) {
      window.setTimeout(apply, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(apply, 0);
  });
})();
